import React from 'react';
import classNames from 'classnames';
import { ArrowIcon } from '../../icons';
import InfoIconGray from '../../../assets/images/info-icon-gray.svg';

const FloatConfirmationStage = ({
	children,
	facilityChanges,
	unitsOptions,
	shiftType,
	unitName,
	shift,
	isSplitShift
}) => {
	const isSameFacility = Number(facilityChanges.facility.value) === shift.facility_id;

	const splitShiftWarningBanner = isSplitShift ? (
		<div className="split-shift-float-warning-banner">
			<img src={InfoIconGray} alt="" />
			<span>
				<b>WARNING:</b> The current shift is a Split shift. Once a shift is floated, it will no longer be Split.
			</span>
		</div>
	) : null;

	return (
		<>
			{splitShiftWarningBanner}

			{children}

			<section>
				<div className="summary-table__title">Facility and unit change after float:</div>
				<table className="summary-table" role="table">
					<tbody>
						<tr className="summary-table__row">
							<td className="summary-table__headercell">Facility</td>
							<td className="summary-table__cell">
								{isSameFacility ? (
									<span className="summary-table__new">{facilityChanges.facility.label}</span>
								) : (
									<>
										<span className="summary-table__old">{shift.facility_name}</span>
										<span className="summary-table__arrow" aria-hidden>
											<ArrowIcon />
										</span>
										<span className="summary-table__new">{facilityChanges.facility.label}</span>
									</>
								)}
							</td>
						</tr>
						<tr
							className={classNames('summary-table__row', {
								'summary-table__last-item': !unitsOptions?.length
							})}
						>
							<td className="summary-table__headercell">Shift type</td>
							{facilityChanges.structure.is_matching ? (
								<td className="summary-table__cell">
									<span className="summary-table__new">{facilityChanges.structure.name}</span>
								</td>
							) : (
								<td className="summary-table__cell">
									<span className="summary-table__old">{shiftType}</span>
									<span className="summary-table__arrow" aria-hidden>
										<ArrowIcon />
									</span>
									<span className="summary-table__new">{facilityChanges.structure.name}</span>
								</td>
							)}
						</tr>
						{unitsOptions?.length > 0 && (
							<tr className="summary-table__row summary-table__last-item">
								<td className="summary-table__headercell">Unit</td>
								<td className="summary-table__cell">
									{unitName !== '-' || !!facilityChanges.unit ? (
										<>
											<span
												className={classNames({
													'summary-table__new': unitName === '-',
													'summary-table__old': unitName !== '-'
												})}
											>
												{unitName}
											</span>
											<span className="summary-table__arrow" aria-hidden>
												<ArrowIcon />
											</span>
											<span className="summary-table__new">{facilityChanges.unit || '-'}</span>
										</>
									) : (
										<>-</>
									)}
								</td>
							</tr>
						)}
					</tbody>
				</table>
			</section>
		</>
	);
};

export default FloatConfirmationStage;
